import FieldErrors from 'Components/FieldErrors'
import type { ErrorFields } from 'Components/FieldErrors/FieldErrors'
import type { MultiCodeCampaignDetailShape } from 'Services/SalesManagement/Features/Campaign/campaignSlice'
import { TextField } from '@mui/material'
import Box from '@mui/material/Box'
import type { FC, default as React } from 'react'
import { t } from 'ttag'

type CampaignDetailErrors = ErrorFields<MultiCodeCampaignDetailShape>

const MultiCodeCampaignDetails: FC<{
  campaignDetails: MultiCodeCampaignDetailShape
  fieldErrors: CampaignDetailErrors
  handleSetDetails: (
    value: string | number | string[] | Date,
    name: keyof MultiCodeCampaignDetailShape
  ) => void
}> = ({ campaignDetails, handleSetDetails, fieldErrors }) => {
  const handleDiscountCodeCountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    handleSetDetails(parseInt(value), 'discount_code_count')
  }

  return (
    <Box>
      <TextField
        sx={{ minWidth: 200 }}
        required
        type="number"
        label={t`Number of codes`}
        value={campaignDetails.discount_code_count}
        onChange={handleDiscountCodeCountChange}
        error={fieldErrors.discount_code_count?.length > 0}
        helperText={
          <FieldErrors error={fieldErrors.discount_code_count} identifier="discount_code_count" />
        }
      />
    </Box>
  )
}

export { MultiCodeCampaignDetails }
